/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

var TD_COLOR_USED_COLORS_MAX_SIZE = 100;
var COLOR_MODES = {
  monochrome: "\u5355\u8272",
  "linear-gradient": "\u6E10\u53D8"
};
var DEFAULT_COLOR = "#001F97";
var DEFAULT_LINEAR_GRADIENT = "linear-gradient(90deg, rgba(241,29,0,1) 0%, rgba(73,106,220,1) 100%);";
var DEFAULT_SYSTEM_SWATCH_COLORS = ["#ECF2FE", "#D4E3FC", "#BBD3FB", "#96BBF8", "#699EF5", "#4787F0", "#266FE8", "#0052D9", "#0034B5", "#001F97", "#FDECEE", "#F9D7D9", "#F8B9BE", "#F78D94", "#F36D78", "#E34D59", "#C9353F", "#B11F26", "#951114", "#680506", "#FEF3E6", "#F9E0C7", "#F7C797", "#F2995F", "#ED7B2F", "#D35A21", "#BA431B", "#9E3610", "#842B0B", "#5A1907", "#E8F8F2", "#BCEBDC", "#85DBBE", "#48C79C", "#00A870", "#078D5C", "#067945", "#056334", "#044F2A", "#033017"];
var SATURATION_PANEL_DEFAULT_WIDTH = 230;
var SATURATION_PANEL_DEFAULT_HEIGHT = 168;
var SLIDER_DEFAULT_WIDTH = 186;
var GRADIENT_SLIDER_DEFAULT_WIDTH = 176;

export { COLOR_MODES, DEFAULT_COLOR, DEFAULT_LINEAR_GRADIENT, DEFAULT_SYSTEM_SWATCH_COLORS, GRADIENT_SLIDER_DEFAULT_WIDTH, SATURATION_PANEL_DEFAULT_HEIGHT, SATURATION_PANEL_DEFAULT_WIDTH, SLIDER_DEFAULT_WIDTH, TD_COLOR_USED_COLORS_MAX_SIZE };
//# sourceMappingURL=constants.js.map
